<div class="flex gap-3" [class.justify-end]="isMine" data-testid="details-comments-container-comment-entry">
    <!-- Avatar (only for others) -->
    @if (!isMine) {
        <div class="h-8 w-8 rounded-full flex-shrink-0 flex items-center justify-center mt-1 bg-white/10 select-none">
            <span class="text-xs text-shui-text-active font-semibold">{{ initials }}</span>
        </div>
    }

    <section
        class="flex flex-col gap-2 text-sm p-4 pt-2 rounded-md min-w-0 flex-1 sm:flex-none sm:max-w-[min(80%,720px)] sm:min-w-[350px]"
        [ngClass]="isMine ? 'bg-shui-base-4' : 'bg-shui-base-3'"
    >
        <!-- Author name -->
        <span
            class="font-semibold text-base text-shui-text-strong"
            data-testid="details-comments-container-comment-author"
            [class.hidden]="isMine"
        >
            {{ comment().createdBy.firstName | titlecase }}
            {{ comment().createdBy.lastName | titlecase }}
        </span>

        <!-- Body (HTML from rich text editor) -->
        <div
            class="whitespace-pre-wrap text-sm text-shui-text-strong"
            data-testid="details-comments-container-comment-body"
            [innerHTML]="comment().body"
        ></div>

        <!-- File attachments -->
        @if (comment().files?.length) {
            <div class="flex flex-wrap gap-2 mt-1">
                @for (file of comment().files; track file.name) {
                    <button
                        type="button"
                        class="flex items-center gap-2 px-3 py-1.5 bg-transparent border border-white/20 rounded-lg text-xs text-shui-text-moderate hover:bg-white/10 transition-colors cursor-pointer"
                        (click)="onFileClick(file.name)"
                    >
                        <sh-icon icon="document" size="xs"></sh-icon>
                        <span class="truncate max-w-[160px]">{{ file.name }}</span>
                    </button>
                }
            </div>
        }

        <!-- Footer: internal badge + timestamp -->
        <div class="flex items-center justify-between gap-2 mt-1 select-none">
            @if (comment().internal) {
                <span
                    id="comment-internal-badge"
                    class="flex items-center gap-1 text-xs text-shui-text-subtle"
                    data-testid="details-comments-container-internal-badge"
                >
                    <sh-icon icon="lock" size="xs" color="var(--shs-orange)"></sh-icon>
                    {{ 'common.request-detail.comments.internal-message' | translate }}
                </span>
                <sh-tooltip
                    [label]="'common.request-detail.comments.only-visible-for-internal-users' | translate"
                    target="comment-internal-badge"
                    placement="bottom"
                ></sh-tooltip>
            } @else {
                <span></span>
            }
            <span class="text-xs text-shui-text-disabled" data-testid="details-comments-container-comment-timestamp">
                {{ comment().createdAt | date: 'shortDate' }}
                {{ comment().createdAt | date: 'shortTime' }}
            </span>
        </div>
    </section>
</div>
